import { useProfileContext } from '../../../Contexts/ProfileContext';
import useFormattedCurrency from '../../../Hooks/useFormattedCurrency';

export const useServiceFormatter = () => {
  const { userCurrency, currencyConversionRate } = useProfileContext();

  const { startingPriceFormatter } = useFormattedCurrency({
    currency: userCurrency,
    conversionRate: currencyConversionRate,
  });

  const isLastService = (serviceIndex: string | number, services: any[]) => {
    return parseInt(serviceIndex.toString(), 10) === services.length - 1;
  };

  const isFirstService = (serviceIndex: string | number) => {
    return parseInt(serviceIndex.toString(), 10) === 0;
  };

  return {
    startingPriceFormatter,
    isLastService,
    isFirstService,
  };
};
